import { FunctionComponent, memo } from "react";
import { IProps } from "./phrase-triggers-per-day-legend.types";
import { Tooltip } from "@edgetier/components";
import "./phrase-triggers-per-day-legend.scss";

/**
 * Custom legend component for stacked interactions tagged chart
 * @param props.legendData Details about legend details from recharts
 */
const PhraseTriggersPerDayLegend: FunctionComponent<IProps> = ({ legendData }) => {
    return (
        <div className="phrase-triggers-per-day-legend">
            {legendData.map((entry, index) => (
                <Tooltip
                    content={<div className="phrase-triggers-per-day-legend__tooltip-content">{entry.value}</div>}
                    delayEnter={250}
                    useArrow
                    placement="bottom-center"
                    key={`item-${index}`}
                >
                    <div className="phrase-triggers-per-day-legend__entry">
                        <div
                            className="phrase-triggers-per-day-legend__colour-sample"
                            style={{ backgroundColor: entry.color }}
                        ></div>
                        <div className="phrase-triggers-per-day-legend__text">{entry.value}</div>
                    </div>
                </Tooltip>
            ))}
        </div>
    );
};

export default memo(PhraseTriggersPerDayLegend);
